/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleCampaignFromJSON, ApiSimpleCampaignToJSON, } from './ApiSimpleCampaign';
export function ApiReadCampaignResponseFromJSON(json) {
    return ApiReadCampaignResponseFromJSONTyped(json, false);
}
export function ApiReadCampaignResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaign': !exists(json, 'campaign') ? undefined : ApiSimpleCampaignFromJSON(json['campaign']),
    };
}
export function ApiReadCampaignResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaign': ApiSimpleCampaignToJSON(value.campaign),
    };
}
